import { useSmartProp } from '@smartfire/js-block-engine';
import { ToolbarGroup, ToolbarButton } from '@wordpress/components';

const Toolbar = () => {
    const [alignment, setAlignment] = useSmartProp('alignment');

    return (
        <ToolbarGroup>
            <ToolbarButton
                isPressed={alignment === 'left'}
                icon="align-left"
                label="Left"
                onClick={() => setAlignment('left')}
            />
            <ToolbarButton
                isPressed={alignment === 'middle'}
                icon="align-center"
                label="Middle"
                onClick={() => setAlignment('middle')}
            />
            <ToolbarButton
                isPressed={alignment === 'right'}
                icon="align-right"
                label="Right"
                onClick={() => setAlignment('right')}
            />
        </ToolbarGroup>
    );
};

export default Toolbar;
